
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

export type Constructor<T> = new (...args: any[]) => T;

@Injectable({ providedIn: 'root' })
export abstract class GenericService<TDto> {
  protected  apiUrl: string;

  constructor(protected http: HttpClient) {}

  private buildParams(paramsObj: Record<string, any>): HttpParams {
    let params = new HttpParams();
    Object.entries(paramsObj).forEach(([k, v]) => {
      if (v != null) {
        params = params.append(k, String(v));
      }
    });
    return params;
  }

  public get(id: string, customerId: string): Promise<TDto> {
    const options = { params: this.buildParams({ id, customerId }) };
    return lastValueFrom(this.http.get<TDto>(`${this.apiUrl}/get`, options));
  }

  public getAll(customerId: string): Promise<TDto[]> {
    const options = { params: this.buildParams({ customerId }) };
    return lastValueFrom(this.http.get<TDto[]>(`${this.apiUrl}/getAll`, options));
  }

  public create(dto: TDto, customerId: string): Promise<TDto> {
    const options = { params: this.buildParams({ customerId }) };
    return lastValueFrom(this.http.post<TDto>(`${this.apiUrl}/create`, dto, options));
  }

  public update(dto: TDto, customerId: string): Promise<TDto> {
    const options = { params: this.buildParams({ customerId }) };
    return lastValueFrom(this.http.put<TDto>(`${this.apiUrl}/update`, dto, options));
  }

  public delete(id: string, customerId: string): Promise<void> {
    const options = { params: this.buildParams({ id, customerId }) };
    return lastValueFrom(this.http.delete<void>(`${this.apiUrl}/delete`, options));
  }
}